import styled from 'styled-components';

import { mediaWide } from '@xing-com/layout-tokens';
import { scale050, spaceM, spaceL } from '@xing-com/tokens';
import { Column } from '@xing-com/xing-grid';

export const StyledHalfWidthColumn = styled(Column)<{
  $fullWidthLayout: boolean;
}>`
  margin-bottom: ${scale050};

  @media ${mediaWide} {
    margin-bottom: ${spaceM};

    ${({ $fullWidthLayout }) =>
      $fullWidthLayout &&
      `
      &:nth-child(3) {
        margin-top: 0;
      }
    `}
  }
`;

export const StyledFullWidthColumn = styled(Column)`
  margin: ${spaceL} 0;

  &:nth-child(1) {
    margin-top: 0;
  }
`;
